/* global jQuery COMPONENTS */

COMPONENTS.ComponentTeam = (function ($) {
  function ComponentTeam () {
    this.$component = $('[data-ecs-component="team"]')
    this.$teamGrid = $('[data-ecs-component="team-grid"]')
    this.$filterButtons = $('[data-ecs-components-team-category]')
    this.defaultCategory = $('[data-ecs-components-team-category-default]').data('ecs-components-team-category-default')
    this.gridOpts = {
      itemSelector: '[data-ecs-components-element="team-member"]',
      layoutMode: 'masonry',
      filter: this.defaultCategory
    }

    this.$accordion = $('[data-ecs-components-control="team-accordion"]')
    this.$accordionToggles = $('[data-ecs-accordion-control]')
  }

  ComponentTeam.prototype.doFilter = function () {
    const component = this

    if (component.$teamGrid.length >= 1) {
      this.$teamGrid.imagesLoaded(function () {
        component.$teamGrid.isotope(component.gridOpts)
      })
    }
  }

  ComponentTeam.prototype.init = function () {
    const component = this

    component.$filterButtons.each(function () {
      const $button = jQuery(this)

      $button.click(function () {
        component.$filterButtons.each(function () {
          $(this).removeClass('ecs_active')
        })

        $button.addClass('ecs_active')
        component.gridOpts.filter = $(this).data('ecs-components-team-category')
        component.doFilter()
      })
    })

    component.doFilter()

    if (component.$accordion.length >= 1) {
      // no accordion on page
      component.$accordion.accordion({
        exclusive: false,
        animateChildren: false
      })
    }

    $(component.$accordionToggles).each(function () {
      $(this).click(function () {
        const $needle = $(this).attr('data-ecs-accordion-control')
        $('.title[data-ecs-accordion="' + $needle + '"]').click()
      })
    })

    $(window).on('load', function () {
      component.doFilter()
    })

    $(window).on('resize orientationchange', function () {
      // Recalc heights when the viewport size changes or the tablet is rotated
      component.doFilter()
    })
  }

  return ComponentTeam
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentTeam = new COMPONENTS.ComponentTeam()
  COMPONENTS.componentTeam.init()
})
